<template>
  <a-card :bordered="false">
    <a-steps v-model:current="current" type="navigation" size="small" :style="{
            marginBottom: '20px',
            boxShadow: '0px -1px 0 0 #e8e8e8 inset',
          }">
      <a-step status="finish" :disabled="type!='edit'" title="1.基础信息设置" />
      <a-step status="finish" :disabled="type!='edit'" title="2.二维码范围设置" />
      <a-step status="finish" :disabled="type!='edit'" title="3.消费者扫码页面设置" />
    </a-steps>
    <div class="content   " v-if="current == 0">
      <setpsOne ref="one" v-on:oneDone="oneDoneHandle" :id="id" />
    </div>
    <div class="content   " v-if="current == 1">
      <setpsTwo ref="two" v-on:setpsTwoNext="setpsTwoNext" v-on:setpsTwoProvide="setpsTwoProvide" :id="id" />
    </div>
    <div class="content   " v-if="current == 2">
      <setpsTree ref="tree"  v-on:setpsTreeProvide="current--" :id="id" />
    </div>
  </a-card>
</template>
<script>
import setpsOne from "./components/setpsOne";
import setpsTwo from "./components/setpsTwo";
import setpsTree from "./components/setpsTree";
import { ref } from "@vue/reactivity";
import { inject, onMounted } from "@vue/runtime-core";
export default {
  components: { setpsOne, setpsTwo, setpsTree },
  setup() {
    const current = ref(-1);
    const $route = inject("$route");
    const id = ref(null);
    const oneDoneHandle = (target) => {
      if (!$route.query.id) {
        id.value =target
      }
      console.log(current.value)
      current.value += 1;
    };
    onMounted(() => {
      if ($route.query.id) {
        id.value = Number($route.query.id);
      }
      current.value = 0;
    });
    const setpsTwoNext = () => {
      current.value += 1;
    };
    const setpsTwoProvide = () => {
      current.value -= 1;
    };
    return {
      current,
      id,
      oneDoneHandle,
      setpsTwoNext,
      setpsTwoProvide,
    };
  },
};
</script>